/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_DescriptionInputs */

const en_admin_categories_description = /** @type {(inputs: Admin_Categories_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage content categories`)
};

const zh_admin_categories_description = /** @type {(inputs: Admin_Categories_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理内容分类`)
};

/**
* | output |
* | --- |
* | "Manage content categories" |
*
* @param {Admin_Categories_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_description = /** @type {((inputs?: Admin_Categories_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_description(inputs)
	return zh_admin_categories_description(inputs)
});
export { admin_categories_description as "admin.categories.description" }